module.exports = __webpack_public_path__ + "media/images/hébergements-d861fc91ed802b1a7ad6f8d41e12668b.svg";